<template>
  <div>
    <span>{{ name }}</span>
    <span>{{ address }}</span>
    <span class="phone">{{ phone }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    address: String,
    phone: String
  }
};
</script>

<style lang="scss" scoped>
div {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  color: #595959;
  font-weight: bold;
  font-size: 14px;

  .phone {
    text-align: right;
  }
}

@media (max-width: 767px) {
  div {
    grid-template-columns: 1fr !important;

    .phone {
      text-align: left !important;
    }
  }
}
</style>
